/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Raw_Puma_KnitInputs */

const en_bold_raw_puma_knit = /** @type {(inputs: Bold_Raw_Puma_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve all`)
};

const de_bold_raw_puma_knit = /** @type {(inputs: Bold_Raw_Puma_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle genehmigen`)
};

/**
* | output |
* | --- |
* | "Approve all" |
*
* @param {Bold_Raw_Puma_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_raw_puma_knit = /** @type {((inputs?: Bold_Raw_Puma_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Raw_Puma_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_raw_puma_knit(inputs)
	return de_bold_raw_puma_knit(inputs)
});